import { STEPS, useCrossdockingSteps } from '@onward-delivery/core';
import { OnwardCardMobile } from '../OrderDetailsPage/Card';
import Claimed from '../OrderDetailsPage/Crossdocking/Claimed';
import Assigned from '../OrderDetailsPage/Crossdocking/Assigned';
import Received from '../OrderDetailsPage/Crossdocking/Received';
import PickedUp from '../OrderDetailsPage/Crossdocking/PickedUp';
import Complete from '../OrderDetailsPage/Crossdocking/Complete';
import Crossdocked from '../OrderDetailsPage/Crossdocking/Crossdocked';
import CrossdockPickup from '../OrderDetailsPage/Crossdocking/CrossdockPickup';
import Attempt from '../OrderDetailsPage/Crossdocking/Attempt';
import { Grid } from '@material-ui/core';
import { genAttributes } from '@onward-delivery/core';
import { useMemo } from 'react';
import zipcode_to_timezone from 'zipcode-to-timezone';

const DriverCrossdockStepper = ({ order, events, warehouse, isLoading, callbacks }) => {
    // Align props with the main Crossdocking card so shared step components don't crash
    // (many expect `lastEvent.event_id`, `isReceived`, `tz`, etc).
    const tz = useMemo(() => {
        const { zip } = genAttributes(order);
        return (
            zipcode_to_timezone.lookup(order?.[zip]) ||
            Intl.DateTimeFormat().resolvedOptions().timeZone ||
            'America/New_York'
        );
    }, [order]);

    const params = {
        order,
        events,
        isLoading,
        warehouse,
        callbacks,
        isDesktop: false,
        isReceived: (events || []).some((e) => e.action === 'START:AWAITING'),
        isCrossdocked: (events || []).some((e) => (e.action || '').endsWith(':ADD_CD')),
        lastEvent: (events || [])[Math.max((events || []).length - 1, 0)] || {},
        tz,
        readOnly: false,
        finalMileDriver: null,
        crossdockDriver: null,
    };

    const steps = useCrossdockingSteps(events, order?.order_type);
    const driverSteps = steps.slice(
        steps.findLastIndex(([step, meta]) =>
            [STEPS.PICKED_UP, STEPS.CROSS_DOCKED, STEPS.CROSS_DOCK_PICKUP].includes(step)
        )
    );

    const content = driverSteps.map(([step, meta]) => {
        switch (step) {
            case STEPS.CLAIMED:
                return <Claimed {...meta} {...params} />;
            case STEPS.RECEIVED:
                return <Received {...meta} {...params} />;
            case STEPS.PICKED_UP:
                return <PickedUp {...meta} {...params} />;
            case STEPS.COMPLETE:
                return <Complete {...meta} {...params} />;
            case STEPS.CROSS_DOCKED:
                return <Crossdocked {...meta} {...params} />;
            case STEPS.CROSS_DOCK_PICKUP:
                return <CrossdockPickup {...meta} {...params} />;
            case STEPS.ATTEMPT:
                return <Attempt {...meta} {...params} />;
            case STEPS.RETURN_TO_SENDER:
                return <ReturnToSender {...meta} {...params} />;
        }
    });

    return (
        <OnwardCardMobile>
            <Grid direction="column" container>
                {content}
            </Grid>
        </OnwardCardMobile>
    );
};

export default DriverCrossdockStepper;
